"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.productFragment = exports.productShippingMethodsFragment = exports.productPricingFragment = exports.productVariantFragment = exports.selectedAttributeFragment = exports.baseProductFragment = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const checkout_1 = require("./checkout");
exports.baseProductFragment = (0, graphql_tag_1.default) `
  fragment BaseProduct on Product {
    id
    name
    slug
    seoDescription
    isAvailableForPurchase
    availableForPurchase
    seoTitle
    thumbnail {
      url
      alt
    }
    thumbnail2x: thumbnail(size: 510) {
      url
    }
    retailValue {
      currency
      amount
    }
  }
`;
exports.selectedAttributeFragment = (0, graphql_tag_1.default) `
  fragment SelectedAttributeFields on SelectedAttribute {
    attribute {
      id
      name
      slug
    }
    values {
      id
      name
      slug
    }
  }
`;
exports.productVariantFragment = (0, graphql_tag_1.default) `
  ${checkout_1.checkoutPriceFragment}
  fragment ProductVariantFields on ProductVariant {
    id
    sku
    name
    rentalDays
    quantityAvailable(countryCode: $countryCode)
    images {
      id
      url
      alt
    }
    pricing {
      onSale
      priceUndiscounted {
        ...Price
      }
      price {
        ...Price
      }
      borrowerFee {
        net {
          amount
        }
        gross {
          amount
        }
      }
    }
    attributes(variantSelection: $variantSelection) {
      attribute {
        id
        name
        slug
      }
      values {
        id
        name
        value: name
      }
    }
  }
`;
exports.productPricingFragment = (0, graphql_tag_1.default) `
  ${checkout_1.checkoutPriceFragment}
  fragment ProductPricingField on Product {
    pricing {
      onSale
      priceRangeUndiscounted {
        start {
          ...Price
        }
        stop {
          ...Price
        }
      }
      priceRange {
        start {
          ...Price
        }
        stop {
          ...Price
        }
      }
    }
  }
`;
exports.productShippingMethodsFragment = (0, graphql_tag_1.default) `
  ${checkout_1.checkoutPriceFragment}
  fragment ProductShippingMethodsFields on Product {
    shippingMethods(countryCode: "au") {
      name
      id
      description
      price {
        currency
        amount
      }
      maximumDeliveryDays
      minimumDeliveryDays
    }
  }
`;
exports.productFragment = (0, graphql_tag_1.default) `
  ${exports.baseProductFragment}
  ${exports.selectedAttributeFragment}
  ${exports.productVariantFragment}
  ${exports.productPricingFragment}
  ${exports.productShippingMethodsFragment}
  fragment ProductDetails on Product {
    ...BaseProduct
    ...ProductPricingField
    description
    isDeleted
    category {
      id
      name
      slug
    }
    images {
      id
      url
      mobileUrl: url(size: 510)
    }
    attributes {
      ...SelectedAttributeFields
    }
    variants {
      ...ProductVariantFields
    }
    productAggregateRating {
      ratingValue
      ratingCount
    }
    ...ProductShippingMethodsFields
    isAvailable
    resource {
      id
      bookings {
        dates {
          date
        }
      }
      preparationDays
    }
    lender {
      name
      avatar(size: 440) {
        url
      }
      rating
      slug
      user {
        id
      }
      lenderOrdersMade(status: [FULFILLED, ARCHIVED])
      isb
    }
    retailValue {
      currency
      amount
    }
    sizeFitNotes
    location
    defaultVariant {
      id
    }
    originalPurchasePrice {
      currency
      amount
    }
    hasWarehouseSale
    isb
    purchaseStatus
    isDraft
  }
`;
//# sourceMappingURL=products.js.map